import React from "react";
import {useDebouncedCallback} from "use-debounce";

import {Datepicker} from "@mobiscroll/react";
import Stack from '@mui/material/Stack';

import {LoadingButton} from "../shared/loading-button";
import Search from "../search";

export const MetricsProspectsFilters = ({parentState, parentDispatch, getData, handleExport}) => {
  const debouncedGetData = useDebouncedCallback(
    getData,
    500,
  );

  const handleDatesInputChange = (range) => {
    parentDispatch({type: 'datesRangeChanged', dates: range.value});
  }

  const handleBlur = () => {
    if (parentState.datesChangedAfterLastRequest) {
      getData();
    }
  };

  const handleSearch = (e) => {
    parentDispatch({type: "search", value: e.target.value.toLowerCase()});

    debouncedGetData();
  };

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="baseline" my={3}>
      <Stack direction="row" gap={3} alignItems="baseline">
        <h6>DATES</h6>
        <Datepicker
          select="range"
          returnFormat="iso8601"
          controls={['date']}
          value={parentState.dates}
          placeholder="__/__/____ - __/__/____"
          onChange={handleDatesInputChange}
          onClose={handleBlur}
          themeVariant="light"
          inputProps={{
            readOnly: true,
            className: "dates-range-light-input metrics-prospects",
          }}
          disabled={parentState.isExporting}
        />
      </Stack>

      <Stack direction="row" gap={3}>
        <Search
          placeholder="Search"
          onSearch={handleSearch}
          query={parentState.search}
          disabled={parentState.isExporting}
        />
        <LoadingButton
          onClick={handleExport}
          isLoading={parentState.isExporting}
          disabled={parentState.isExporting}
          className="base-button evo-blue"
        >
          Export
        </LoadingButton>
      </Stack>
    </Stack>);
}